// Tiny dropdown shell used by HomeBookingWidget for the "Choose a
// property" popover. Renders nothing while closed; when open it
// mounts an invisible full-screen click-catcher for dismissal plus
// the actual panel.

import React from "react";

const BookingDropdown = ({
  open,
  onClose,
  children,
  anchorClass = "left-0",
  widthClass = "w-[min(92vw,28rem)]",
}) => {
  if (!open) return null;
  return (
    <>
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="fixed inset-0 z-30 cursor-default"
        tabIndex={-1}
      />
      <div
        className={`absolute top-full mt-2 z-40 ${anchorClass} ${widthClass} bg-[#FDFBF7] border border-[#2C2621]/15 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.35)]`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </>
  );
};

export default BookingDropdown;
